<template>
  <header>
    <div class="logo">
      <router-link :to="`/${$i18n.locale}`">
        <logo></logo>
      </router-link>
    </div>
    <div class="language-toggle">
      <a @click.prevent="toggleLanguage()">
        {{ $t('toggle-language-short') }}
      </a>
    </div>
    <services-component></services-component>
    <user-component></user-component>
  </header>

  <main>
    <router-view></router-view>
  </main>

  <footer>
    <div>{{ version }}-{{ serverVersion }}</div>
    <div>© {{ year }} Mentor Canada</div>
  </footer>

  <FeedbackComponent product="quality-mentoring-system" :lang="lang" />
  <snack-bar></snack-bar>

</template>

<script lang="ts" setup>
import Logo from './Logo.vue';
import UserComponent from './UserComponent.vue';
import ServicesComponent from './ServicesComponent.vue';
import Manager from "./Manager";
import { provide } from 'vue';
import i18n from '../locale/i18n';
import SnackBar from "../components/SnackBar.vue";
import { getLocale } from './Utils';

provide('t', i18n.global.t);

const serverInfo = Manager.getInstance().serverInfo;

const version = VERSION;
const serverVersion = serverInfo.version;
const year = serverInfo.year
const lang = getLocale();

const toggleLanguage = () => {
  let pathComponents = window.location.pathname.split('/');
  const queryParameters = window.location.search
  pathComponents[1] = Manager.getInstance().i18n.global.locale == 'en' ? 'fr' : 'en';
  const url = `${pathComponents.join('/')}${queryParameters}`;
  window.location.href = url;
}
</script>
